const HttpStatusCodeMessage = {
  getMessage: function (status) {
    switch (status) {
      case 400:
        return '400 Bad Request'

      case 401:
        return '401 Unauthorized'

      case 403:
        return '403 Forbidden'

      case 404:
        return '設備連線逾時 404 Not Found'

      case 408:
        return '408 Request Timeout'

      case 500:
        return '500 Internal Server Error'

      case 501:
        return '501 Not Implemented'

      case 502:
        return '502 Bad Gateway'

      case 503:
        return '503 Service Unavailable'

      case 504:
        return '設備連線逾時 504 Gateway Timeout'

      default:
        return status + ' error'
    }
  }
}

export default HttpStatusCodeMessage
